import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import PropTypes from 'prop-types';

import TabSelector from './TabSelector';
import HeaderText from '../../../shared/_TBComponents/HeaderText';

import iconSet from '../../../shared/images/teambuildr-selection.json';
import { ColorPrimary, ColorWhite, TransitionGlobal } from '../../../shared/GlobalStyles';

import {
  setActiveReduxModal,
} from '../ducks/journalActions';
import { journalTracker } from '../../../shared/utils/amplitudeHelper';

const FilterContainer = styled('div')`
  align-items: center;
  display: flex;
`;

const FilterIconContainer = styled('div')`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 4px 8px 0 rgba(48, 49, 51, 0.05);
  height: 42px;
  width: 42px;
  background-color: ${ColorWhite};
  transition: ${TransitionGlobal};
  position: relative;

  :hover {
    opacity: 0.7;
  }
`;

const FilterOptionsCount = styled('div')`
  height: 13px;
  width: 13px;
  border-radius: 50%;
  background-color: ${ColorPrimary};
  color: ${ColorWhite};
  font-size: 11px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
`;

const JournalHeaderDiv = styled('div')`
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 15px 15px 0 15px;
  position: sticky;
  top: 49px;
  z-index: 101;

  @media screen and (max-width: 640px) {
    max-width: 100%;
    min-width: 380px;
    width: 100%;
  }

  @media screen and (max-width: 576px) {
    min-width: 312px;
    padding-left: 0;
    padding-right: 0;
  }
`;

const UpperHeaderBox = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 540px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const Header = ({ scrollToTop }) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const { mediaOnly, dateRange, filterExercise } = useSelector((state) => state.journal.data);
  const dispatch = useDispatch();

  const filterOptionsCount = useMemo(() => {
    let count = 0;
    if (mediaOnly) {
      count += 1;
    }
    if (filterExercise?.id) {
      count += 1;
    }
    if (dateRange?.startDate && dateRange?.endDate) {
      count += 1;
    }
    return count;
  }, [mediaOnly, dateRange, filterExercise]);

  const coachAccount = currentUser?.admin > 0;

  const handleFilterClick = useCallback(() => {
    dispatch(setActiveReduxModal('filter-options-modal'));
    journalTracker('Main page', 'Filter options modal opened');
  }, [dispatch]);

  return (
    <JournalHeaderDiv className='journal-header'>
      <UpperHeaderBox>
        <HeaderText fontWeight='300' letterSpacing='normal'>Journal</HeaderText>
        <FilterContainer>
          <FilterIconContainer aria-label='Open filter options' onClick={handleFilterClick}>
            <IcomoonReact iconSet={iconSet} size={22} icon='filter' color={ColorPrimary} />
            {filterOptionsCount > 0 && (
              <FilterOptionsCount>{filterOptionsCount}</FilterOptionsCount>
            )}
          </FilterIconContainer>
        </FilterContainer>
      </UpperHeaderBox>
      {coachAccount && <TabSelector scrollToTop={scrollToTop} />}
    </JournalHeaderDiv>
  );
};

Header.propTypes = {
  scrollToTop: PropTypes.func.isRequired,
};

export default Header;
